import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { setDocumentTitle, sortVariableStatisticsByType } from '../../util';
import { getTranslation, withLang } from '../../i18n';
import WithStatistics from '../WithStatistics';
import VariableSummaryChart from '../VariableSummaryChart';
import styles from './dimensionStatistics.module.css';
import DimensionQuestionsSummary from '../DimensionQuestionsSummary';
import { surveyStatsType, surveyInfoType, surveyScheduleType } from '../../constants/types';
import TranslatedHTMLText from '../TranslatedHTMLText';

class DimensionStatistics extends Component {
  constructor(props) {
    super(props);
    this.renderDimensionQuestions = this.renderDimensionQuestions.bind(this);
    this.state = {};
  }

  renderDimensionQuestions() {
    const {
      surveyStats, params, lang, translate
    } = this.props;
    const allVariableStatistics = sortVariableStatisticsByType(surveyStats.variableStatistics);
    const variableStats = allVariableStatistics[params.dimensionId];
    const { name, summaryDescription } = variableStats;
    setDocumentTitle(getTranslation(name, lang));
    return [
      <div className={styles.variableContainer} key="variableContainer">
        <h2 className={styles.variableHeader}>{getTranslation(name, lang)}</h2>

        <div className={styles.infoContainer}>
          <div className={styles.chartContainer}>
            <VariableSummaryChart
              stats={variableStats}
              lang={lang}
              translate={translate}
              showStandardDeviation
              label={getTranslation(name, lang)}
            />
          </div>
          {/* WARNING: UH-670 - Might not be accessible if the html is not formatted correctly */}
          {summaryDescription && Object.keys(summaryDescription)
          && (
          <TranslatedHTMLText className={styles.descriptionContainer} html={summaryDescription} />
          )}

        </div>
      </div>,
      <div key="questionContainer">
        <h2 className={styles.variableHeader}>{translate('surveyStatistics.dimensionStatements')}</h2>

        <DimensionQuestionsSummary
          surveyStats={surveyStats}
          questionCodes={variableStats.questionCodes}
        />
      </div>
    ];
  }

  render() {
    const { surveyStats, surveyInfo, surveySchedule } = this.props;
    const t = this.props.translate;

    const renderSummaryComponent = () => {
      if (surveyStats && surveyStats.computingStatistics) {
        return <h3>{t('surveyStatistics.computingStatistics')}</h3>;
      }
      if (surveyInfo && !surveyInfo.hasEnoughResponses) {
        return <h3>{t('surveyStatistics.notEnoughResponses')}</h3>;
      }
      if (surveySchedule && !surveySchedule.ended) {
        return <h3>{t('surveyStatistics.noStatsUntilClosed')}</h3>;
      }
      if (surveyStats) {
        return this.renderDimensionQuestions();
      }
      return null;
    };

    return (surveyInfo && surveySchedule
      ? (
        <div className="page-container">
          <div className={styles.back}>
            <Link
              className="theme-transparent button--action-before icon--arrow-left"
              to=".."
            >{t('common.back')}
            </Link>
          </div>

          { renderSummaryComponent() }

        </div>
      ) : null
    );
  }
}

const { shape, string, func } = PropTypes;

DimensionStatistics.propTypes = {
  surveyStats: surveyStatsType,
  surveyInfo: surveyInfoType,
  surveySchedule: surveyScheduleType,
  params: shape({
    surveyId: string
  }).isRequired,
  translate: func.isRequired,
  lang: string.isRequired
};

DimensionStatistics.defaultProps = {
  surveyStats: null,
  surveyInfo: null,
  surveySchedule: null
};

export default withLang(WithStatistics(DimensionStatistics));
